import React from 'react';
import Card from './Card/Card';
import BounceLoader from './BounceLoader';

export default function LoadingCard({
  title,
  text,
  withBackground,
  ...props,
}) {
  return (
    <Card
      className={`${withBackground ? 'with-background' : ''}`}
      title={title}
      data-name="loading-card"
      {...props}
    >
      <div className="text-center">
        <BounceLoader />
        { text && <p>{text}</p> }
      </div>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/LoadingCard.js